module.exports = __webpack_public_path__ + "img/logoterra.675ebefd.jpg";